document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".ticker-stat");

    const animate = (counter) => {
        const text = counter.textContent.trim();
        const match = text.match(/[\d,.]+/);

        if (!match) {
            return;
        }

        const value = parseFloat(match[0].replace(/,/g, ""));
        const prefix = text.slice(0, match.index);
        const suffix = text.slice(match.index + match[0].length);

        const duration = 2500;
        const totalFrames = Math.round(duration / (1000 / 60));
        let frame = 0;

        const step = () => {
            frame++;
            const progress = frame / totalFrames;
            const eased = 1 - Math.pow(1 - progress, 4);

            let current = value * eased;
            current = match[0].includes(".") ? current.toFixed(1) : Math.floor(current);

            counter.textContent = `${prefix}${current}${suffix}`;

            if (frame < totalFrames) {
                requestAnimationFrame(step);
            } else {
                counter.textContent = text;
            }
        };

        step();
    };

    const counterObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    animate(entry.target);
                }, 500);

                obs.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    });

    counters.forEach(counter => counterObserver.observe(counter));
});

document.addEventListener("DOMContentLoaded", function () {
    const widgets = document.querySelectorAll(".js-ticker-bar");

    const animateTickerBar = function (widget) {
        const rows = Array.from(widget.querySelectorAll(".ticker-bar-row"));

        if (!rows.length) {
            return;
        }

        const values = rows.map(function (row) {
            const raw = row.getAttribute("data-value") || "";
            const cleaned = raw.replace(/[^0-9.-]+/g, "");
            const num = parseFloat(cleaned);

            return isNaN(num) ? 0 : num;
        });

        const min = Math.min.apply(null, values);
        const max = Math.max.apply(null, values);

        const minWidth = 40;
        const maxWidth = 100;

        const primaryColor = "#0033A0";
        const secondaryColor = "#A4D65E";
        const tertiaryColor = "#002D72";

        const grayStart = 180;
        const grayEnd = 140;

        const grayCount = Math.max(rows.length - 3, 0);

        rows.forEach(function (row, index) {
            const bar = row.querySelector(".ticker-bar");

            if (!bar) {
                return;
            }

            const raw = row.getAttribute("data-value") || "";
            const cleaned = raw.replace(/[^0-9.-]+/g, "");
            const value = parseFloat(cleaned) || 0;

            let width = maxWidth;

            if (max !== min) {
                const ratio = (value - min) / (max - min);
                width = minWidth + ((maxWidth - minWidth) * ratio);
            }

            let barColor = "#8d8d93";
            let textColor = "#fff";

            if (index === rows.length - 1) {
                barColor = primaryColor;
                textColor = "#fff";
            } else if (index === rows.length - 2) {
                barColor = secondaryColor;
                textColor = "#000";
            } else if (index === rows.length - 3) {
                barColor = tertiaryColor;
                textColor = "#fff";
            } else {
                if (grayCount <= 1) {
                    barColor = "rgb(" + grayStart + "," + grayStart + "," + grayStart + ")";
                } else {
                    const grayStep = (grayEnd - grayStart) / (grayCount - 1);
                    const grayValue = Math.round(grayStart + (grayStep * index));

                    barColor = "rgb(" + grayValue + "," + grayValue + "," + grayValue + ")";
                }

                textColor = "#fff";
            }

            bar.style.setProperty("--bar-color", barColor);
            bar.style.color = textColor;
            bar.style.width = "0%";

            setTimeout(function () {
                bar.style.width = width + "%";
            }, 300 + (index * 250));
        });
    };

    const tickerBarObserver = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                animateTickerBar(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    });

    widgets.forEach(function (widget) {
        tickerBarObserver.observe(widget);
    });
});